import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import { Map } from 'immutable'
import ImmutableProptypes from 'react-immutable-proptypes'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import classnames from 'classnames'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Modal from 'react-modal'
import IdleTimer from 'react-idle-timer'
import DesktopNotification from 'react-web-notification'

import Header from '_components/header'
import { clearNotifications, deleteNotification } from '_modules/notification/actions'
import {
  resetIntervalId,
  resetCounterRedux,
  startTimer,
  decrementCounter,
} from '_modules/counter/actions'
import {
  getCollaborators,
  getInvitesSent,
  getInvitesReceived,
  getNotesReceived,
  getNotesSent,
} from '_modules/collaboration/actions'
import { logout, getProfileInfo } from '_modules/user/actions'
import { getMindfulBreaks } from '_modules/mindful-breaks/actions'
import { startTask, stopTask } from '_modules/current-task/actions'
import { getMindfulBreakDuration } from '_utils/counter'
import { planTypes } from '_utils/planType'
import { USER_STATUS_TYPES } from '_utils/userStatusType'
import Socket from '_utils/socket'
import isOnline from '_utils/isOnline'
import BG1 from '_images/backgrounds/bgr_1.jpg'
import BG2 from '_images/backgrounds/bgr_2.jpg'
import BG3 from '_images/backgrounds/bgr_3.jpg'
import BG4 from '_images/backgrounds/bgr_4.jpg'
import BG5 from '_images/backgrounds/bgr_5.jpg'
import BG6 from '_images/backgrounds/bgr_6.jpg'
import BG7 from '_images/backgrounds/bgr_7.jpg'
import BG8 from '_images/backgrounds/bgr_8.jpg'
import POGLOGO from '_images/POG LOGO.png'
import audioBeep from '_audio/347379__gevaroy__bells-1.wav'

import styles from './styles.css'

const backgrounds = [BG1, BG2, BG3, BG4, BG5, BG6, BG7, BG8]
const backgroundStyle = { position: 'absolute', width: '100%', height: '100%' }

const menuItems = [
  {
    title: 'Now',
    link: '/',
    key: 'now',
    lock: planTypes.free,
  },
  {
    title: 'Today',
    link: '/today',
    key: 'today',
    lock: planTypes.pro,
  },
  {
    title: 'Tasks',
    link: '/tomorrow',
    key: 'tomorrow',
    lock: planTypes.pro,
  },
  {
    title: 'Collaboration',
    link: '/collaborate',
    key: 'collaborate',
    lock: planTypes.team,
  },
  {
    title: 'Mindful Breaks',
    link: '/break',
    key: 'break',
    lock: planTypes.free,
  },
]

const ErrorContainer = ({ style, hidden, message }) => {
  return (
    <div
      className={classnames(styles.errorContainer)}
      style={{
        opacity: hidden ? 0 : 1,
        zIndex: hidden ? -1 : 999,
        top: 50,
        ...style,
      }}
    >
      {message}
    </div>
  )
}
const toastOptions = {
  position: 'top-right',
  autoClose: false,
  newestOnTop: false,
  closeOnClick: false,
  closeButton: false,
  rtl: false,
}

const mapStateToProps = ({
  counter,
  user,
  notifications,
  mindfulBreaks,
  settings,
  refresh,
  currentTask,
}) => ({
  counter,
  user,
  notifications,
  mindfulBreaks,
  settings,
  refresh,
  currentTask,
})

const mapDispatchToProps = {
  resetIntervalId,
  logout,
  getProfileInfo,
  getMindfulBreaks,
  clearNotifications,
  startTask,
  startTimer,
  decrementCounter,
  resetCounterRedux,
  getCollaborators,
  getInvitesSent,
  getInvitesReceived,
  getNotesReceived,
  getNotesSent,
  deleteNotification,
  stopTask,
}

class App extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    counter: ImmutableProptypes.map,
    user: ImmutableProptypes.map,
    notifications: ImmutableProptypes.map,
    mindfulBreaks: ImmutableProptypes.map,
    settings: ImmutableProptypes.map,
    currentTask: ImmutableProptypes.map,
    logout: PropTypes.func.isRequired,
    getProfileInfo: PropTypes.func.isRequired,
    getMindfulBreaks: PropTypes.func.isRequired,
    decrementCounter: PropTypes.func.isRequired,
    clearNotifications: PropTypes.func.isRequired,
    resetCounterRedux: PropTypes.func.isRequired,
    startTimer: PropTypes.func.isRequired,
    startTask: PropTypes.func.isRequired,
    deleteNotification: PropTypes.func.isRequired,
    stopTask: PropTypes.func.isRequired,
  }

  static defaultProps = {
    children: null,
    counter: new Map(),
    user: new Map(),
    notifications: new Map(),
    mindfulBreaks: new Map(),
    settings: new Map(),
    refresh: new Map(),
    currentTask: new Map(),
  }

  constructor(props) {
    super(props)
    this.state = {
      showNav: true,
      activeBackgroundIndex: 0,
      activeBackgrounds: [
        { id: 0, element: <img key={0} style={backgroundStyle} src={BG1} alt="" /> },
      ],
      refreshCollabId: 0,
      isModalOpen: false,
      modalName: '',
      modalMessage: '',
      modalId: undefined,
      timeout: 3600000,
      isIdle: false,
      ignore: true,
      title: '',
      notificationShown: false,
      errorShown: false,
      errorMessage: '',
      errorPosition: {},
    }

    setInterval(() => {
      const { activeBackgroundIndex } = this.state
      const nextBackgroundIndex =
        activeBackgroundIndex < backgrounds.length - 1 ? activeBackgroundIndex + 1 : 0

      this.setState({
        activeBackgroundIndex: nextBackgroundIndex,
        activeBackgrounds: [
          {
            id: nextBackgroundIndex,
            element: (
              <img
                key={nextBackgroundIndex}
                style={backgroundStyle}
                src={backgrounds[nextBackgroundIndex]}
                alt=""
              />
            ),
          },
        ],
      })
    }, 10000)
  }

  isOnlineToastId = null

  componentDidMount() {
    // called on refresh
    if (this.props.user.get('token')) {
      this.props.getProfileInfo()
      this.props.getMindfulBreaks()
    }
    // check for online
    setInterval(() => {
      isOnline()
        .then(online => {
          if (!online && !navigator.onLine) {
            if (!toast.isActive(this.isOnlineToastId)) {
              this.isOnlineToastId = toast.error(
                'Hello Mindful requires internet connection to work, check your internet connection',
                {
                  position: toast.POSITION.TOP_RIGHT,
                  type: 'warning',
                  autoClose: false,
                  onClose: () => (this.isOnlineToastId = null),
                }
              )
            }
          } else {
            if (this.isOnlineToastId) {
              toast.dismiss(this.isOnlineToastId)
              this.isOnlineToastId = null
            }
          }
        })
        .catch(err => console.log(err))
    }, 5000)
  }

  componentWillReceiveProps({ counter, notifications, settings, user }) {
    if (!this.socketInitialized && user.get('id')) {
      Socket.connect()
      this.socketInitialized = true
    }

    if (!user.get('id')) {
      this.socketInitialized = false
    }

    // notify 3 times, every 2 minutes
    if (
      !this.state.notificationShown &&
      (counter.get('counter') === 0 ||
        counter.get('counter') === -120 ||
        counter.get('counter') === -240)
    ) {
      if (settings.get('sound')) {
        // this.audioRef.load()
        this.audioRef.play().catch(err => {
          console.log('error', err.code, err.message, err.name)
          if (err.code === DOMException.NotSupportedError) {
            toast.error(`Sound could not be played, ${err}`, {
              position: toast.POSITION.TOP_RIGHT,
              type: 'warning',
              autoClose: false,
              onClose: () => {},
            })
          }
        })
        // this.audioRef.load()
      }
      this.handleShowDesktopNotification()
    }

    // when timer ends
    if (
      counter.get('counter') !== this.props.counter.get('counter') &&
      counter.get('counter') === 0 &&
      counter.get('name') !== null
    ) {
      // check for notifications for after interval notifications
      notifications
        .toArray()
        .map(x => x.toJS())
        .forEach(x => {
          if (x.type === 1) {
            this.displayNotification(x)
          }
        })
    }
  }

  onSkipPressed = () => {
    const { modalId: id } = this.state
    // update & close notification if no more notifications to show
    const notifications = this.props.notifications.toJS()

    this.props.deleteNotification({ id: id.toString() })

    this.resetModal()
  }

  onProceedPressed = () => {
    // const name = e.currentTarget.name
    const { modalName: name } = this.state
    const { mindfulBreaks, counter, currentTask } = this.props

    // clear all notification
    this.props.clearNotifications()

    // check if timer still running, clear redux and update backend
    if (counter.get('intervalId')) {
      clearInterval(counter.get('intervalId'))
    }
    this.props.resetCounterRedux()

    // check if there is a current task, switch it
    if (currentTask.get('logEntry')) {
      this.props.stopTask(currentTask.get('logEntry'), {})
    }

    // start redux timer
    const duration = getMindfulBreakDuration(mindfulBreaks, name) * 60
    const intervalId = setInterval(this.timer, 1000)
    this.props.startTimer(intervalId, name, duration, 2)

    // create task in backend
    const payload3 = {
      name,
      type: 2,
      duration,
    }
    this.props.startTask(payload3)
    this.resetModal()
  }

  onActiveAction = () => {
    Socket.emit('changeUserStatus', this.props.user.status)
  }

  onIdleAction = () => {
    Socket.emit('changeUserStatus', USER_STATUS_TYPES.INACTIVE)
  }

  setAudioRef = ref => {
    this.audioRef = ref
  }

  displayNotification = x => {
    this.setState({
      modalName: x.breakName,
      modalMessage: x.message,
      modalId: x.id,
      isModalOpen: true,
    })
  }

  displayError = (title, style) => {
    this.setState(
      {
        errorShown: true,
        errorMessage: title,
        errorPosition: style,
      },
      () => setTimeout(this.clearError, 3000)
    )
  }

  clearError = () =>
    this.setState({
      errorShown: false,
      errorMessage: '',
      errorPosition: {},
    })

  timer = () => {
    this.props.decrementCounter()
  }

  disableNav = () => {
    this.setState({
      showNav: false,
    })
  }

  toggleModal = () => {
    this.setState({
      isModalOpen: !this.state.isModalOpen,
    })
  }

  resetModal = () => {
    this.setState({
      isModalOpen: false,
      modalName: '',
      modalMessage: '',
      modalId: undefined,
    })
  }

  // Desktop notifications function
  handlePermissionGranted = () => {
    console.log('Permission Granted')
    this.setState({
      ignore: false,
    })
  }

  handlePermissionDenied = () => {
    console.log('Permission Denied')
    this.setState({
      ignore: true,
    })
  }

  handleNotSupported = () => {
    console.log('Web Notification not Supported')
    this.setState({
      ignore: true,
    })
  }

  handleNotificationOnClick = (e, tag) => {
    console.log(e, 'Notification clicked tag:' + tag)
  }

  handleNotificationOnError = (e, tag) => {
    console.log(e, 'Notification error tag:' + tag)
  }

  handleNotificationOnClose = (e, tag) => {
    console.log(e, 'Notification closed tag:' + tag)
    this.setState({ notificationShown: false })
  }

  handleNotificationOnShow = (e, tag) => {
    console.log(e, 'Notification shown tag:' + tag)
  }

  handleShowDesktopNotification = message => {
    if (this.state.ignore) {
      return
    }
    const now = Date.now()

    const title = message || `Take a mindful moment: ${this.props.counter.get('name')}.`
    const body = ''
    const tag = now
    // const icon = 'http://localhost:3000/Notifications_button_24.png';

    // Available options
    // See https://developer.mozilla.org/en-US/docs/Web/API/Notification/Notification
    const options = {
      tag,
      body,
      // icon: icon,
      lang: 'en',
      dir: 'ltr',
      requireInteraction: true,
      // sound: './sound.mp3'  // no browsers supported https://developer.mozilla.org/en/docs/Web/API/notification/sound#Browser_compatibility
    }
    this.setState(
      {
        title,
        options,
        notificationShown: true,
      },
      () => {
        // reset notificaitonShown so it works on firefox / safari
        setTimeout(() => {
          this.setState({
            notificationShown: false,
          })
        }, 2000)
      }
    )
  }

  render() {
    const { activeBackgrounds, showNav, isModalOpen, modalMessage, modalName } = this.state
    const { children, user, logout: logoutFunc } = this.props
    const planType = user.get('planType', 100) * 1
    return (
      <IdleTimer
        ref="idleTimer"
        element={document}
        activeAction={this.onActiveAction}
        idleAction={this.onIdleAction}
        timeout={this.state.timeout}
      >
        <div className={styles.root}>
          <DesktopNotification
            ignore={this.state.ignore && this.state.title !== ''}
            notSupported={this.handleNotSupported}
            onPermissionGranted={this.handlePermissionGranted}
            onPermissionDenied={this.handlePermissionDenied}
            onShow={this.handleNotificationOnShow}
            onClick={this.handleNotificationOnClick}
            onClose={this.handleNotificationOnClose}
            onError={this.handleNotificationOnError}
            timeout={9000000000}
            title={this.state.title}
            options={this.state.options}
          />
          <ToastContainer bodyClassName={classnames(styles.toastBody)} />
          <ErrorContainer
            style={this.state.errorPosition}
            hidden={!this.state.errorShown}
            message={this.state.errorMessage}
          />
          <div style={{ position: 'absolute', width: '100%', height: '100%' }}>
            <TransitionGroup>
              {activeBackgrounds.map(({ id, element }) => (
                <CSSTransition
                  key={id}
                  timeout={{ enter: 900, exit: 9000 }}
                  classNames="background"
                >
                  {element}
                </CSSTransition>
              ))}
            </TransitionGroup>
          </div>
          <div style={{ position: 'absolute', width: '100%', height: '100%' }}>
            {showNav && <Header user={user} logout={logoutFunc} displayError={this.displayError} />}
            <div className={classnames(styles.Grid, styles['Grid--alignMiddle'], styles.body)}>
              {showNav && (
                <nav className={classnames(styles['Grid-cell'], styles['u-sizeFit'])}>
                  {menuItems.map(({ title, link, key, lock }) =>
                    lock > planType * 1 ? (
                      <Link
                        key={key}
                        name={key}
                        to={'/subscribe'}
                        activeClassName={styles['active-link']}
                        className={classnames(styles.menuItems)}
                      >
                        {title} <i className="fa fa-lock" />
                      </Link>
                    ) : (
                      <Link
                        key={key}
                        name={key}
                        to={link}
                        activeClassName={styles['active-link']}
                        className={classnames([title === 'Now' ? styles.now : styles.menuItems])}
                      >
                        {title}
                      </Link>
                    )
                  )}
                  <img className={styles.logo} src={POGLOGO} alt="" />
                </nav>
              )}
              <main
                id="mainApp"
                className={classnames(
                  styles['Grid-cell'],
                  styles['u-sizeFill'],
                  showNav ? styles.padRight : null
                )}
              >
                {React.cloneElement(children, {
                  disableNav: this.disableNav,
                  displayNotification: this.displayNotification,
                  displayError: this.displayError,
                  clearError: this.clearError,
                  audioRef: this.audioRef,
                  handleShowDesktopNotification: this.handleShowDesktopNotification,
                })}
              </main>
              <Modal
                isOpen={isModalOpen}
                className={classnames(styles.modal)}
                overlayClassName={classnames(styles.overlay)}
                onRequestClose={this.toggleModal}
                bodyOpenClassName={classnames(styles['disable-body-scroll'])}
              >
                <div>
                  <p className={classnames(styles.modalMessage)}>{modalMessage}</p>
                  <button
                    className={classnames(styles['Grid-cell'], styles['u-sizeFit'], styles.button)}
                    onClick={this.onSkipPressed}
                  >
                    SKIP
                  </button>
                  <button
                    className={classnames(styles['Grid-cell'], styles['u-sizeFit'], styles.button)}
                    onClick={this.onProceedPressed}
                  >
                    PROCEED
                  </button>
                </div>
              </Modal>
            </div>
            <audio ref={this.setAudioRef} src={audioBeep} />
          </div>
        </div>
      </IdleTimer>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App)



// WEBPACK FOOTER //
// ./src/views/app/index.js